<template>
    <div class="container">
        <!-- HEADER -->
        <h1 class="row col-12 page-title">Advanced Search</h1>
        <div class="row mt-4">
            <div class="col-12 mb-3">
                  <div class="pt-2 mb-2"> 
            <button @click=" back()" :to="`/datasets/${getID}`" class="page-btn border-0"> 
                 <i class="material-icons mr-1">keyboard_arrow_left</i>
                Back to Quick Search
            </button>
        </div>
            </div>
            <div class="col flex-grow-1">
                <!-- SCOPE TAB BAR -->
                <div id="scope-select-advanced" class="d-none d-md-block">
                    <div>
                        <div class="scope-select-block">
                            <div class="nav-item mb-0" role="tab"
                                :class="selectedOption === 'all' ? 'router-link-active' : 'router-link-inactive'">
                                <a @click="selectOption('all')" class="nav-link"
                                    :class="selectedOption === 'all' ? 'router-link-active' : 'router-link-inactive'"
                                    role="presentation">
                                    <div class="scope-tab-content">
                                        <span class="label">All</span>
                                        <!-- <span v-if="!isLoading && getTotalCount >= 0" class="count">{{
                                            formattedTotalCount }}</span>
                                        <span v-else-if="!isLoading" class="count">?</span>
                                        <span v-else class="count loading-dots">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </span> -->
                                    </div>
                                </a>
                            </div>
                            <div class="nav-item mb-0" role="tab"
                                :class="selectedOption === 'datasets' ? 'router-link-active' : 'router-link-inactive'">
                                <a @click="selectOption('datasets')" class="nav-link"
                                    :class="selectedOption === 'datasets' ? 'router-link-active' : 'router-link-inactive'"
                                    role="presentation">
                                    <div class="scope-tab-content">
                                        <span class="label">{{ $t('message.header.navigation.data.datasets') }}</span>
                                        <!-- <span v-if="!isLoading && getDatasetsCount >= 0" class="count">{{
                                            formattedDatasetsCount }}</span>
                                        <span v-else-if="!isLoading" class="count">?</span>
                                        <span v-else class="count loading-dots">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </span> -->
                                    </div>
                                </a>
                            </div>
                            <div class="nav-item mb-0" role="tab"
                                :class="selectedOption === 'catalogues' ? 'router-link-active' : 'router-link-inactive'">
                                <a @click="selectOption('catalogues')" class="nav-link"
                                    :class="selectedOption === 'catalogues' ? 'router-link-active' : 'router-link-inactive'"
                                    role="presentation">
                                    <div class="scope-tab-content">
                                        <span class="label">{{ $t('message.datasetFacets.facets.catalog') }}</span>
                                        <!-- <span v-if="!isLoading && getCatalogsCount >= 0" class="count">{{
                                            formattedCatalogsCount }}</span>
                                        <span v-else-if="!isLoading" class="count">?</span>
                                        <span v-else class="count loading-dots">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </span> -->
                                    </div>
                                </a>
                            </div>
                            <div class="nav-item mb-0" role="tab"
                                :class="selectedOption === 'dataservices' ? 'router-link-active' : 'router-link-inactive'">
                                <a @click="selectOption('dataservices')" class="nav-link"
                                    :class="selectedOption === 'dataservices' ? 'router-link-active' : 'router-link-inactive'"
                                    role="presentation">
                                    <div class="scope-tab-content">
                                        <span class="label">{{ $t('message.header.navigation.data.dataservices') }}</span>
                                    </div>
                                </a>
                            </div>
                            <div class="nav-item mb-0" role="tab"
                                :class="selectedOption === 'datasetseries' ? 'router-link-active' : 'router-link-inactive'">
                                <a @click="selectOption('datasetseries')" class="nav-link"
                                    :class="selectedOption === 'datasetseries' ? 'router-link-active' : 'router-link-inactive'"
                                    role="presentation">
                                    <div class="scope-tab-content">
                                        <span class="label">{{ $t('message.header.navigation.data.datasetseries') }}</span>
                                    </div>
                                </a>
                            </div>
                              <div class="nav-item mb-0" role="tab"
                                :class="selectedOption === 'editorial-content' ? 'router-link-active' : 'router-link-inactive'">
                                <a @click="selectOption('editorial-content')" class="nav-link"
                                    :class="selectedOption === 'editorial-content' ? 'router-link-active' : 'router-link-inactive'"
                                    role="presentation">
                                    <div class="scope-tab-content">
                                        <span class="label">{{ $t('message.searchTabs.editorialContent') }}</span>
                                        <!-- <span v-if="!isLoading && getEditorialContentCount >= 0" class="count">{{
                                            formattedEditorialContentCount }}</span>
                                        <span v-else-if="!isLoading" class="count">?</span>
                                        <span v-else class="count loading-dots">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </span> -->
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <!-- SCOPE DROPDOWN MO -->
                <div class="d-block d-md-none mobile-dropdown" ref="mobileDropdown">
                    <button type="button" class="mobile-trigger" @click="mobileDropdownOpen = !mobileDropdownOpen"
                        :aria-expanded="mobileDropdownOpen.toString()" aria-haspopup="listbox">
                        <span class="trigger-label">{{ mobileCurrentOption.label }}</span>
                        <span class="count-badge">{{ mobileCurrentOption.count }}</span>
                        <span class="divider"></span>
                        <span class="arrow" :class="{ open: mobileDropdownOpen }"></span>
                    </button>
                    <ul v-if="mobileDropdownOpen" class="mobile-menu" role="listbox"
                        :aria-activedescendant="selectedOption">
                        <li v-for="opt in mobileOptions" :key="opt.value" :id="opt.value" role="option"
                            :aria-selected="opt.value === selectedOption">
                            <button type="button" @click="selectMobileOption(opt.value)">
                                <span class="opt-label">{{ opt.label }}</span>
                                <span class="badge-inline">{{ opt.count }}</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-auto d-none d-sm-block">
                <!-- SUBMIT BUTTONS -->
                <div class="d-flex text-end">
                    <button class="ecl-button ecl-button--secondary mr-2" @click="clearAll()">{{
                        $t('message.dataupload.clear') }}</button>
                    <button class="ecl-button ecl-button--primary" @click="applySearch()">{{
                        $t('message.header.subnav.search') }}</button>
                </div>
            </div>
        </div>
        <!-- SEARCH BOX -->
        <div class="mt-3 box">
            <div class="row">
                <div class="col-12 col-md-8">
                    <h2>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-search" viewBox="0 0 16 16">
                            <path
                                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                        </svg> {{ $t('message.header.subnav.search') }} in
                    </h2>
                    <div class="form mt-4">
                        <form>
                            <div class="label mb-2">Search</div>
                            <div class="wrapper">
                                <div ref="highlight" class="highlighted-content"></div>
                                <textarea type="text" class="text mb-2" v-model="currentQueryValue" tabindex="-1"
                                    :placeholder="$t('message.header.subnav.search') + ' in selected properties'"
                                    id="search" @keydown.enter.prevent="handleEnter" @input="handleInput"
                                    @scroll="handleScroll" @focus="setActive('search')"
                                    :class="{ 'filled-input': currentQueryValue }" ref="editor" @blur="handleBlur">
            </textarea>
                                <button v-if="currentQueryValue" class="clear-btn" @click="clearInput()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </button>
                            </div>

                            <!-- Search Properties Checkboxes (nur für datasets, catalogues und all anzeigen) -->
                            <div class="mb-4 mt-3" v-if="selectedOption !== 'editorial-content'">
                                <div class="label mb-3">Search in properties
                                    <i class="tooltip-icon material-icons small-icon align-right text-dark pl-1"
                                        data-toggle="tooltip" data-placement="top" data-html="true" data-trigger="hover"
                                        title="This section defines the search scope. Selecting “All properties” searches across all available metadata fields. To search within specific metadata fields (e.g., title or description), select the relevant checkboxes. Searches can also be limited to metadata fields in a specific language. “My language” applies the currently selected UI language, while “All languages” searches across all available languages for the chosen metadata field.">
                                        help_outline
                                    </i>
                                </div>

                                <div class="checkbox-group">
                                    <div class="all-props">
                                        <ECCheckbox id="all-checkbox" :label="'All properties'"
                                            :checked="searchFields.length === 0"
                                            @change="(state) => handleAllPropertiesChange(state)" />
                                    </div>
                                    <div class="language-search">
                                        <div class="checkbox-row">
                                            <ECCheckbox id="title-checkbox" :label="$t('message.metadata.title')"
                                                :checked="searchFields.includes('title.*')"
                                                @change="(state) => handleECCheckboxChange('title.*', state)" />
                                            <ECCheckbox id="description-checkbox"
                                                :label="$t('message.metadata.description')"
                                                :checked="searchFields.includes('description.*')"
                                                @change="(state) => handleECCheckboxChange('description.*', state)" />
                                            <ECCheckbox id="keywords-checkbox"
                                                :label="$t('message.datasetFacets.facets.keywords')"
                                                :checked="searchFields.includes('keywords.*')"
                                                @change="(state) => handleECCheckboxChange('keywords.*', state)" />
                                            <ECCheckbox id="categories-checkbox"
                                                :label="$t('message.metadata.categories')"
                                                :checked="searchFields.includes('categories.*')"
                                                @change="(state) => handleECCheckboxChange('categories.*', state)" />
                                        </div>
                                        <div class="language-selection">
                                            <div class="date-type-radio-group">
                                                <label class="radio-option"
                                                    :class="{ 'disabled': searchFields.length === 0 }">
                                                    <input type="radio" v-model="selectedLanguage" :value="locale"
                                                        name="language" @change="updateLanguageInUrl"
                                                        :disabled="searchFields.length === 0">
                                                    <span class="radio-label">My language</span>
                                                </label>
                                                <label class="radio-option"
                                                    :class="{ 'disabled': searchFields.length === 0 }">
                                                    <input type="radio" v-model="selectedLanguage" value="*"
                                                        name="language" @change="updateLanguageInUrl"
                                                        :disabled="searchFields.length === 0">
                                                    <span class="radio-label">All languages</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Category Suggestions (nur wenn categories ausgewählt ist) -->
                            <div v-if="showSuggestions && filteredSuggestions.length > 0 && searchFields.includes('categories.*')"
                                class="suggestions-container">
                                <div v-for="suggestion in filteredSuggestions" :key="suggestion" class="suggestion-item"
                                    @click="selectSuggestion(suggestion)">
                                    {{ suggestion }}
                                    <span class="category-label">Category</span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- INFO BOX-->
                <div class="col-12 col-md-3 info-box">
                    <h3> Search Operators</h3>
                    <div class="details mt-3">
                        <li>AND / OR / NOT</li>
                        <li>"" exact phrase search</li>
                        <li>* replace 0 to n characters</li>
                        <li>? replace a single character</li>
                        <div>
                            <a href="https://dataeuropa.gitlab.io/data-provider-manual/how-to-search/search-for-datasets/"
                                class="ecl-button ecl-button--secondary btn-more mt-4" target="_blank">
                                {{ $t('message.cookieConsent.more') }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-box-arrow-up-right ml-1" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                    <path fill-rule="evenodd"
                                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Date BOX -->
        <div class="mt-4 box" v-if="this.selectedOption === 'datasets' || this.selectedOption === 'all'">
            <h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-calendar-event" viewBox="0 0 16 16">
                    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                    <path
                        d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                </svg>
                {{ $t('message.dataupload.datasets.date.label') }}
            </h2>
            
            <!-- FORM GROUP DATE -->
            <div class="form mt-4 date">
                <form>
                    <div class="mb-3">
                        <!-- <div class="label mb-2">Date Filter Type</div> -->
                        <div class="date-type-radio-group">
                            <label class="radio-option">
                                <input type="radio" v-model="dateType" value="modified" name="dateType"
                                    @change="updateUrlWithDateType">
                                <span class="radio-label">{{ $t('message.dataupload.datasets.modified.label') }}  <i class="tooltip-icon material-icons small-icon align-right text-dark pl-1"
                                        data-toggle="tooltip" data-placement="top" data-html="true" data-trigger="hover"
                                        :title="tooltipModified">
                                        help_outline
                </i></span>
                            </label>
                            <label class="radio-option">
                                <input type="radio" v-model="dateType" value="issued" name="dateType"
                                    @change="updateUrlWithDateType">
                                <span class="radio-label">{{ $t('message.dataupload.datasets.issued.label') }}  <i class="tooltip-icon material-icons small-icon align-right text-dark pl-1"
                                        data-toggle="tooltip" data-placement="top" data-html="true" data-trigger="hover"
                                        :title="tooltipIssued">
                                        help_outline
                </i></span>
                            </label>
                            <label class="radio-option">
                                <input type="radio" v-model="dateType" value="temporal" name="dateType"
                                    @change="updateUrlWithDateType">
                                <span class="radio-label">{{ $t('message.metadata.temporal') }}  <i class="tooltip-icon material-icons small-icon align-right text-dark pl-1"
                                        data-toggle="tooltip" data-placement="top" data-html="true" data-trigger="hover"
                                        :title="tooltipTemporal">
                                        help_outline
                </i></span>
                            </label>
                        </div>
                    </div>
                    <!-- <div class="label mb-2">{{ $t('message.dataupload.datasets.modified.label') }}</div> -->
                    <div class="date-picker mb-4">
                        <div class="month-year-picker">
                            <div class="date-input-wrapper">
                                <flat-pickr v-model="minDate" :config="flatpickrConfig" class="date-input"
                                    placeholder="Select" @on-change="(dates) => updateMinDate(dates[0])"
                                    @blur="updateUrlWithDates()" />
                                <button v-if="minDate" class="clear-date-btn" @click="clearMinDate()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </button>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"
                                    aria-hidden="true" class="calendar-icon" role="img" aria-label="Calendar icon">
                                    <path
                                        d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z">
                                    </path>
                                    <path
                                        d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z">
                                    </path>
                                    <path
                                        d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z">
                                    </path>
                                    <path
                                        d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z">
                                    </path>
                                </svg>

                            </div>
                            <span class="dash">&mdash;</span>
                            <div class="date-input-wrapper">
                                <flat-pickr v-model="maxDate" :config="flatpickrConfig" class="date-input"
                                    placeholder="Select" @on-change="(dates) => updateMaxDate(dates[0])"
                                    @blur="updateUrlWithDates()" />
                                <button v-if="maxDate" class="clear-date-btn" @click="clearMaxDate()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </button>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"
                                    aria-hidden="true" class="calendar-icon" role="img" aria-label="Calendar icon">
                                    <path
                                        d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z">
                                    </path>
                                    <path
                                        d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z">
                                    </path>
                                    <path
                                        d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z">
                                    </path>
                                    <path
                                        d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- FILTER BOX -->
        <div class="mt-4 box" v-if="this.selectedOption === 'datasets' || this.selectedOption === 'all'">
            <h2 id="filters-headline"><svg data-v-71b82b0a="" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-funnel" viewBox="0 0 16 16">
                    <path data-v-71b82b0a=""
                        d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z">
                    </path>
                </svg> Filters</h2>

            <div class="facets-row-advanced">
                <div v-for="(facets, colIdx) in chunkedFacets" :key="colIdx">
                    <DatasetsFacets :availableFacets="facets" :showClearButtonAdvanced="false"
                        :facetClicked="facetClickedNoScroll" :dataScope="selectedOption"/>
                </div>
            </div>
        </div>
        <!-- API REQUEST & SUBMIT/CLEAR -->
        <div class="mt-4">
            <div class="row">
                <div class="col-7">
                    <div class="mt-4 box api-request-box d-none d-md-block">
                        <h2>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-code-slash" viewBox="0 0 16 16">
                                <path
                                    d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z" />
                            </svg>
                            API Request
                        </h2>
                        <div class="api-request-content">
                            <div class="api-url-container">
                                <input type="text" class="api-url-field" readonly v-model="apiRequestUrl" />
                                <button class="copy-btn" @click="copyApiUrl" title="In Zwischenablage kopieren">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-clipboard" viewBox="0 0 16 16">
                                        <path
                                            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                                        <path
                                            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                                    </svg>
                                </button>
                            </div>
                            <button @click="openApiRequest()" class="ecl-button ecl-button--primary api-request-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                    <path fill-rule="evenodd"
                                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                </svg>
                                Open API request
                            </button>
                        </div>
                    </div>
                    <div v-if="showCopiedModal" class="copied-modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-check-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path
                                d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                        Copied to clipboard
                    </div>
                </div>
                <div class="col-5 d-flex justify-content-end mb-4 custom-search">
                    <button class="ecl-button ecl-button--secondary mr-2" @click="clearAll()">{{
                        $t('message.dataupload.clear')
                        }}</button>
                    <button class="ecl-button ecl-button--primary" @click="applySearch()">{{
                        $t('message.header.subnav.search')
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    helpers,
} from "@piveau/piveau-hub-ui-modules";
import { has, isNil } from "lodash-es";
import $ from "jquery";
import ECCheckbox from '../ECCheckbox.vue'
import DatasetsFacets from '@/components/search/datasets/datasetFacets/DatasetsFacets.vue'; // <--- hinzufügen
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { German } from 'flatpickr/dist/l10n/de.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { Greek } from 'flatpickr/dist/l10n/gr.js';
import { Hungarian } from 'flatpickr/dist/l10n/hu.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import { Bulgarian } from 'flatpickr/dist/l10n/bg.js';
import { Estonian } from 'flatpickr/dist/l10n/et.js';
import { Croatian } from 'flatpickr/dist/l10n/hr.js';
import { Lithuanian } from 'flatpickr/dist/l10n/lt.js';
import { Latvian } from 'flatpickr/dist/l10n/lv.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Slovak } from 'flatpickr/dist/l10n/sk.js';
import { Slovenian } from 'flatpickr/dist/l10n/sl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

const { getTranslationFor, truncate, getImg, getFacetTranslation } = helpers;

export default {
    name: "AdvancedSearch",
    setup() {
    },
    props: {
        config: Object,
        datasetsCount: {
            type: Number,
            default: 0
        }
    },
    components: {
        ECCheckbox,
        DatasetsFacets,
        flatPickr,
    },
    data() {
        return {
            helpLink: 'https://dataeuropa.gitlab.io/data-provider-manual/how-to-search/search-for-datasets/#date',
            defaultFacetOrder: this.$env.content.datasets.facets.defaultFacetOrder,
            facetFields: [],
            locale: this.$route.query.locale,
            baseUrl: this.$env.api.baseUrl,
            activeField: null,
            query: this.$route.query.query || '',
            titleQuery: this.$route.query.query || '',
            descQuery: this.$route.query.descQuery || '',
            selectedOption: (() => {
                const option = this.$route.query.selectedOption || 'all';
                return option === 'editorial' ? 'editorial-content' : option;
            })(),
           searchFields: this.$route.query.fields ? this.$route.query.fields.split(',').map(field => {
                // Handle categories.label.XX format specifically FIRST
                if (field.match(/^categories\.label\.(de|en|fr|es|it|nl|pl|pt|ru|cs|da|el|hu|bg|et|hr|lt|lv|ro|sk|sl|fi|sv)$/)) {
                    return 'categories.*';
                }
                // Handle keywords.label.XX format specifically
                if (field.match(/^keywords\.label\.(de|en|fr|es|it|nl|pl|pt|ru|cs|da|el|hu|bg|et|hr|lt|lv|ro|sk|sl|fi|sv)$/)) {
                    return 'keywords.*';
                }
                // Handle language-specific fields like title.de, description.en, etc.
                if (field.match(/\.(de|en|fr|es|it|nl|pl|pt|ru|cs|da|el|hu|bg|et|hr|lt|lv|ro|sk|sl|fi|sv)$/)) {
                    return field.replace(/\.[a-z]{2}$/, '.*');
                }
                return field;
            }) : [],
            minDateUTC: this.$route.query.minDate || null,
            maxDateUTC: this.$route.query.maxDate || null,
            keywordsQuery: this.$route.query.keywordsQuery || '',
            categoriesQuery: this.$route.query.categoriesQuery || '',
            searchQueries: {},
            openDropdowns: {},
            categorySuggestions: [
                "Agriculture, fisheries, forestry and food",
                "Economy and finance",
                "Education, culture and sport",
                "Energy",
                "Environment",
                "Government and public sector",
                "Health",
                "International issues",
                "Justice, legal system and public safety",
                "Population and society",
                "Provisional data",
                "Regions and cities",
                "Science and technology",
                "Transport"
            ],
            filteredSuggestions: [],
            showSuggestions: false,
            apiRequestUrl: '',
            includes: `id,title.${this.$route.query.locale || 'en'},description.${this.$route.query.locale || 'en'},languages,modified,issued,catalog.id,catalog.title,catalog.country.id,distributions.id,distributions.format.label,distributions.format.id,distributions.license,categories.label,publisher`,
            showCopiedModal: false,
            dateType: this.$route.query.dateType || 'modified',
            getDatasetsCount: 0,
            getDataservicesCount: 0,
            getDatasetseriesCount: 0,
            getEditorialContentCount: 0,
            getTotalCount: 0,
            getCatalogsCount: 0,
            isLoading: false,
            selectedLanguage: this.$route.query.selectedLanguage || this.$route.query.locale,
            countRequestTimer: null,
            mobileDropdownOpen: false,
        };
    },
    computed: {
        ...mapGetters("datasets", [
            "getDatasets",
            "getAllAvailableFacets",
            "getAvailableFacets",
        ]),
        getCount() {
            return this.$store.getters[`${this.config.getCount[0]}/${this.config.getCount[1]}`];
        },
        getFacets() {
            return this.$store.getters["search/getFacets"] || {};
        },
        flatpickrConfig() {
            return {
                locale: this.currentLocale,
                dateFormat: "Y-m",
                altFormat: "F Y",
                enableTime: false,
                mode: "single",
                static: true,
                monthSelectorType: "static",
                plugins: [
                    new monthSelectPlugin({
                        shorthand: false,
                        dateFormat: "Y-m",
                        altFormat: "F Y",
                        theme: "light",
                        minYear: 1,
                        maxYear: 3000,
                    })
                ]
            };
        },
        currentLocale() {
            const localeMap = {
                'de': German,
                'en': english,
                'fr': French,
                'es': Spanish,
                'it': Italian,
                'nl': Dutch,
                'pl': Polish,
                'pt': Portuguese,
                'ru': Russian,
                'cs': Czech,
                'da': Danish,
                'el': Greek,
                'hu': Hungarian,
                'bg': Bulgarian,
                'et': Estonian,
                'hr': Croatian,
                'lt': Lithuanian,
                'lv': Latvian,
                'ro': Romanian,
                'sk': Slovak,
                'sl': Slovenian,
                'fi': Finnish,
                'sv': Swedish,
            };
            return localeMap[this.locale] || english;
        },
        chunkedFacets() {
            const facets = this.getAllAvailableFacets;
            const colCount = 4;
            const chunkSize = Math.ceil(facets.length / colCount);
            const chunks = [];
            for (let i = 0; i < colCount; i++) {
                chunks.push(facets.slice(i * chunkSize, (i + 1) * chunkSize));
            }
           
            const flatArray = [chunks.flat()];      
             console.log(flatArray); 
             
            return flatArray;
        },
        pageCountSafe() {
            const count = Number(this.getPageCount);
            return count > 0 && isFinite(count) ? count : 1;
        },
        isSpecificPropertiesActive() {
            const specificFields = [`title.${this.selectedLanguage}`, `description.${this.selectedLanguage}`, `keywords.${this.selectedLanguage}`, `categories.${this.selectedLanguage}`];
            return this.searchFields.some(f => specificFields.includes(f));
        },
        currentSearchQuery() {
            return this.$route.query.query;
        },
        showScoreDisclaimer() {
            return this.getMinScoring > 0;
        },

        isErpdActive() {
            return this.$route.query.superCatalog === 'erpd'
                || this.$route.path === '/catalogues/erpd';
        },
        currentQueryValue: {
            get() {
                return this.searchFields.length > 0 ? this.titleQuery : this.query;
            },
            set(value) {
                if (this.searchFields.length > 0) {
                    this.titleQuery = value;
                    this.query = value;
                } else {
                    this.query = value;
                    this.titleQuery = value;
                }
            }
        },
        mobileOptions() {
            return [
                {
                    value: 'all',
                    label: 'All',
                    count: this.formatCount(this.getTotalCount)
                },
                {
                    value: 'datasets',
                    label: this.$t('message.header.navigation.data.datasets'),
                    count: this.formatCount(this.getDatasetsCount)
                },
                {
                    value: 'catalogues',
                    label: this.$t('message.datasetFacets.facets.catalog'),
                    count: this.formatCount(this.getCatalogsCount)
                },
                {
                    value: 'dataservices',
                    label: this.$t('message.header.navigation.data.dataservices'),
                    count: this.formatCount(this.getDataservicesCount)
                },
                {
                    value: 'datasetseries',
                    label: this.$t('message.header.navigation.data.datasetseries'),
                    count: this.formatCount(this.getDatasetseriesCount)
                },
                {
                    value: 'editorial-content',
                    label: this.$t('message.searchTabs.editorialContent'),
                    count: this.formatCount(this.getEditorialContentCount)
                }
            ];
        },
        mobileCurrentOption() {
            return this.mobileOptions.find(o => o.value === this.selectedOption) || this.mobileOptions[0];
        },
        formattedTotalCount() {
            return this.formatCountWithSpaces(this.getTotalCount);
        },
        formattedDatasetsCount() {
            return this.formatCountWithSpaces(this.getDatasetsCount);
        },
        formattedCatalogsCount() {
            return this.formatCountWithSpaces(this.getCatalogsCount);
        },
        formattedDataservicesCount() {
            return this.formatCountWithSpaces(this.getDataservicesCount);
        },
        formattedDatasetseriesCount() {
            return this.formatCountWithSpaces(this.getDatasetseriesCount);
        },
        formattedEditorialContentCount() {
            return this.formatCountWithSpaces(this.getEditorialContentCount);
        },
        tooltipModified() {
           return `Filters datasets by the date they were last updated in the original source portal. The filter applies only to datasets where the metadata field 'modified' is set. <br><br> <a href="${this.helpLink}" target="_blank" class="tooltip-link">Get more details</a><br>`;
       },
        tooltipIssued() {
           return `Filters datasets by their original publication or release date as provided by the original source portal. The filter applies only to datasets where the metadata field 'issued' is set. <br><br> <a href="${this.helpLink}" target="_blank" class="tooltip-link">Get more details</a><br>`;
       },
        tooltipTemporal() {
           return `Filters datasets based on the time period the dataset refers to (e.g., data covering 1880–1920). The filter applies only to datasets where the metadata field 'temporal coverage' is set. <br><br> <a href="${this.helpLink}" target="_blank" class="tooltip-link">Get more details</a><br>`;
       }
    },
    watch: {
        // eslint-disable-next-line object-shorthand
        '$route.query.query': {
            immediate: true,
            handler(newQuery) {
                if (newQuery) {
                    if (this.isSpecificPropertiesActive) {
                        this.titleQuery = newQuery;
                        if (!this.query) {
                            this.query = newQuery;
                        }
                    } else {
                        this.query = newQuery;
                        if (!this.titleQuery) {
                            this.titleQuery = newQuery;
                        }
                    }
                }
            }
        },
        '$route.query': {
            immediate: true,
            handler() {
                const urlSelectedOption = this.$route.query.selectedOption;
                if (urlSelectedOption && urlSelectedOption !== this.selectedOption) {
                    if (urlSelectedOption === 'editorial') {
                        this.selectedOption = 'editorial-content';
                    } else if (urlSelectedOption === 'dataservice') {
                        this.selectedOption = 'dataservices';
                    } else {
                        this.selectedOption = urlSelectedOption;
                    }
                }
                if (this.$route.query.selectedLanguage && this.$route.query.selectedLanguage !== this.selectedLanguage) {
                    this.selectedLanguage = this.$route.query.selectedLanguage;
                }
                this.initFacets();
                this.setFacets(this.facets());
                this.initDatasets();
                this.$nextTick(() => {
                    document.body.style.scrollBehavior = 'auto';
                    setTimeout(() => {
                        document.body.style.scrollBehavior = '';
                    }, 0);
                });

                this.generateApiUrl();
            },
            deep: true
        },
        query(newVal) {
            if (this.$refs.highlight) {
                this.$refs.highlight.innerHTML = this.highlightText(newVal);
            }
        },
        facets: {
            handler(facets) {
                this.setFacets(facets);
            },
            deep: true,
        },
        page(pageStr) {
            const page = parseInt(pageStr, 10);
            if (page > 0) this.setPage(page);
            else this.setPage(1);
        },
        minDateUTC() {
            this.countRequest();
        },
        maxDateUTC() {
            this.countRequest();
        },
        dateType() {
            this.countRequest();
        },
        searchFields: {
            handler() {
                clearTimeout(this.countRequestTimer);
                this.countRequestTimer = setTimeout(() => {
                    this.countRequest();
                }, 300);
            },
            deep: true
        },
        selectedLanguage() {
            clearTimeout(this.countRequestTimer);
            this.countRequestTimer = setTimeout(() => {
                this.countRequest();
            }, 300);
        },
        currentQueryValue() {
            clearTimeout(this.countRequestTimer);
            this.countRequestTimer = setTimeout(() => {
                this.countRequest();
            }, 500); // Longer delay for text input
        }
    },
    methods: {
        ...mapActions("datasets", [
            "loadDatasets",
            "addFacet",
            "setFacets",
            "setPageCount",
        ]),
        initFacets() {
            const fields = this.$env.content.datasets.facets.defaultFacetOrder;
            this.facetFields = fields;
            let needsUpdate = false;
            const newQuery = { ...this.$route.query };

            for (const field of fields) {
                if (!Object.prototype.hasOwnProperty.call(newQuery, field)) {
                    newQuery[field] = [];
                    needsUpdate = true;
                }
            }
            if (needsUpdate) {
                this.$router.replace({ query: newQuery }).catch((error) => {
                    console.error(error);
                });
            }
        },
        facetClickedNoScroll(field, item) {
            const currentQuery = { ...this.$route.query };
            let facets = currentQuery[field] || [];
            if (!Array.isArray(facets)) facets = [facets];

            if (field === 'country') {
                const index = facets.indexOf(item.id);
                if (index > -1) {
                    facets.splice(index, 1);
                } else {
                    facets.push(item.id);
                }
            } else {
                const index = facets.indexOf(item.id);
                if (index > -1) {
                    facets.splice(index, 1);
                } else {
                    facets.push(item.id);
                }
            }
            if (facets.length === 0) {
                delete currentQuery[field];
            } else {
                currentQuery[field] = facets;
            }
            currentQuery.page = 1;
            // WICHTIG: selectedOption explizit beibehalten, um zu verhindern, dass sie zurückgesetzt wird
            currentQuery.selectedOption = this.selectedOption;
            this.$router.replace({ query: currentQuery })
                .then(() => {
                    this.setFacets(this.facets());
                })
                .catch(error => {
                    console.error('Error updating route:', error);
                });
        },
        clearMinDate() {
            event.preventDefault();
            this.minDate = null;
            this.minDateUTC = null;
            this.updateUrlWithDates();
        },
        clearMaxDate() {
            event.preventDefault();
            this.maxDate = null;
            this.maxDateUTC = null;
            this.updateUrlWithDates();
        },
        highlightText(text) {
            const keywords = /\b(AND|OR|NOT)\b/g;
            return text.replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(keywords, '<strong style="background:#0e47cb; color:#fff; padding: 0.5px; font-weight:bold;">$1</strong>');
        },
        async toggleFacet(field, facet) {
            const scrollPosition = window.pageYOffset;
            const currentQuery = { ...this.$route.query };
            let facets = currentQuery[field] || [];

            if (!Array.isArray(facets)) facets = [facets];
            if (field === 'categories') {
                facet = facet.toUpperCase();
                facets = facets.map(f => f.toUpperCase());
            }
            if (field === 'scoring') {
                facets = (facet === 'badScoring') ? [] : [facet];
            } else {
                const index = facets.indexOf(facet);
                if (index > -1) {
                    facets.splice(index, 1);
                } else {
                    facets.push(facet);
                }
            }
            if (facets.length === 0) {
                delete currentQuery[field];
            } else {
                currentQuery[field] = facets;
            }
            currentQuery.page = 1;
            if (this.$route.name === 'AdvancedSearch') {
                try {
                    await this.$router.replace({
                        query: currentQuery,
                        scrollBehavior: () => false
                    });

                    await this.$nextTick();
                    requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPosition);
                    });
                } catch (error) {
                    console.error('Error updating route:', error);
                }
            } else {
                try {
                    await this.$router.replace({ query: currentQuery });
                } catch (error) {
                    console.error('Error updating route:', error);
                }
            }
        },
        handleScroll(e) {
            this.$refs.highlight.scrollTop = e.target.scrollTop;
            this.$refs.highlight.scrollLeft = e.target.scrollLeft;
        },
        isNil,
        setPage(page) {
            this.page = page;
            this.updateQueryParam('page', page);
        },
        async updateFacetsAfterSelection() {
            await this.initDatasets();
            this.setPage(1);
            this.updateQueryParam('selectedOption', this.selectedOption);
            await this.countRequest();
        },
        async countRequest() {
            this.isLoading = true;
            const baseUrl = this.$env.api.baseUrl;
            const UrlQuery = this.$route.query;
            const includes = this.includes || '';

            // Get facets and exclude dataServices from them
            const allFacets = this.facets() || {};
            const { dataServices, ...facetsWithoutDataServices } = allFacets;

            const encodedFacets = encodeURIComponent(JSON.stringify(facetsWithoutDataServices));
            const readableFacets = encodedFacets
                .replace(/%3A/g, ':').replace(/%5B/g, '[')
                .replace(/%5D/g, ']').replace(/%2C/g, ',');

            let dateParams = '';
            if (this.selectedOption === 'datasets' || this.selectedOption === 'all') {
                if (this.minDateUTC) dateParams += `&minDate=${this.minDateUTC}`;
                if (this.maxDateUTC) dateParams += `&maxDate=${this.maxDateUTC}`;
                if (this.dateType && this.dateType !== 'modified') dateParams += `&dateType=${this.dateType}`;
            }

            // Add scoring parameter (metadata quality filter) with min/max ranges
            let scoringParams = '';
            const facets = facetsWithoutDataServices;
            if (facets.scoring && facets.scoring.length > 0) {
                if (facets.scoring.includes("excellentScoring")) {
                    scoringParams = "&minScoring=351";
                } else if (facets.scoring.includes("goodScoring")) {
                    scoringParams = "&minScoring=221&maxScoring=350";
                } else if (facets.scoring.includes("sufficientScoring")) {
                    scoringParams = "&minScoring=121&maxScoring=220";
                }
            }

            // Add searchFields parameter (simplified language conversion)
            let fieldsParams = '';
            if (this.selectedOption !== 'editorial-content' && this.searchFields && this.searchFields.length > 0) {
                const fieldsParam = UrlQuery.fields ? UrlQuery.fields : this.searchFields.map(field => {
                    if (field.endsWith('.*')) {
                        const fieldName = field.replace('.*', '');
                        return `${fieldName}.${this.selectedLanguage}`;
                    }
                    return field;
                }).join(',');
                fieldsParams = `&fields=${fieldsParam}`;
            }

            // Add dataServices parameter
            const dataServicesParam = (UrlQuery.dataServices === 'true' || dataServices?.includes('true'))
                ? "&dataServices=true"
                : "";

            const filter = "&filters=catalogue,dataset,dataservice,datasetseries,resource";
            const params = "&resource=editorial-content&countOnly=true";
            const q = UrlQuery.query ? UrlQuery.query : "";
            const url = `${baseUrl}search?q=${q}${filter}${params}${dateParams}${scoringParams}${fieldsParams}${dataServicesParam}${includes ? "&includes=" + includes : ""}&facets=${readableFacets}`;

            try {
                const r = await fetch(url);
                const d = await r.json();
                const c = d.result?.count || {};
                this.getDatasetsCount = c.dataset || 0;
                this.getDataservicesCount = c.dataservice || 0;
                this.getDatasetseriesCount = c.series || c.datasetseries || 0;
                this.getEditorialContentCount = c['resource_editorial-content'] || 0;
                this.getCatalogsCount = c.catalogue || 0;
                this.getTotalCount = c.total || 0;
            } catch (e) {
                console.error('Error fetching counts:', e);
                this.getDatasetsCount = 0;
                this.getDataservicesCount = 0;
                this.getDatasetseriesCount = 0;
                this.getEditorialContentCount = 0;
                this.getCatalogsCount = 0;
                this.getTotalCount = 0;
            } finally {
                this.isLoading = false;
            }
        },

        // Update generateApiRequestUrl method too
        generateApiRequestUrl() {
            const baseUrl = this.$env.api.baseUrl;
            const urlQuery = this.$route.query;
            let filter;
            if (this.selectedOption === 'all') {
                filter = "&filters=catalogue,dataset,dataservice,datasetseries,resource";
            } else if (this.selectedOption === 'datasets') {
                filter = "&filter=dataset";
            } else if (this.selectedOption === 'catalogues') {
                filter = "&filter=catalogue";
            } else if (this.selectedOption === 'dataservices') {
                filter = "&filter=dataservice";
            } else if (this.selectedOption === 'datasetseries') {
                filter = "&filter=datasetseries";
            } else if (this.selectedOption === 'editorial-content') {
                filter = "&filters=resource&resource=editorial-content";
            }

            const allFacets = this.facets() || {};
            const { dataServices, ...facetsWithoutDataServices } = allFacets;

            // DataServices parameter
            const dataServicesParam = (urlQuery.dataServices === 'true' || dataServices?.includes('true'))
                ? "&dataServices=true" : "";

            let countryDataParam = '';
            // Handle dataScope parameter properly
            if (urlQuery.dataScope) {
                const dataScopeValue = Array.isArray(urlQuery.dataScope) ? urlQuery.dataScope[0] : urlQuery.dataScope;
                if (dataScopeValue === 'countryData') {
                    countryDataParam = '&countryData=true';
                } else if (dataScopeValue === 'io') {
                    countryDataParam = '&dataScope=io';
                } else if (dataScopeValue === 'eu') {
                    countryDataParam = '&dataScope=eu';
                }
            } else if (facetsWithoutDataServices.country && facetsWithoutDataServices.country.length > 0) {
                countryDataParam = '&countryData=true';
            }

            if (facetsWithoutDataServices.country && facetsWithoutDataServices.country.includes("countryData")) {
                facetsWithoutDataServices.country = facetsWithoutDataServices.country.filter(item => item !== "countryData");
            }

            // Scoring parameter with min/max ranges
            let scoringParam = '';
            if (facetsWithoutDataServices.scoring && facetsWithoutDataServices.scoring.length > 0) {
                if (facetsWithoutDataServices.scoring.includes("excellentScoring")) {
                    scoringParam = "&minScoring=351";
                } else if (facetsWithoutDataServices.scoring.includes("goodScoring")) {
                    scoringParam = "&minScoring=221&maxScoring=350";
                } else if (facetsWithoutDataServices.scoring.includes("sufficientScoring")) {
                    scoringParam = "&minScoring=121&maxScoring=220";
                }
            }

            let dateTypeParam = '';
            let minDateParam = '';
            let maxDateParam = '';
            if (this.selectedOption === 'datasets' || this.selectedOption === 'all') {
                dateTypeParam = (this.dateType && this.dateType !== 'modified') ? `&dateType=${this.dateType}` : '';
                minDateParam = this.minDateUTC ? `&minDate=${this.minDateUTC}` : '';
                maxDateParam = this.maxDateUTC ? `&maxDate=${this.maxDateUTC}` : '';
            }

            // Fields parameter (simplified)
            const fieldsParam = (this.selectedOption !== 'editorial-content' && urlQuery.fields) ? `&fields=${urlQuery.fields}` : '';

            if (urlQuery.dataScope && urlQuery.dataScope.length > 0 && urlQuery.dataScope !== "countryData" && urlQuery.dataScope !== "io" && urlQuery.dataScope !== "eu") {
                if (!facetsWithoutDataServices.country) facetsWithoutDataServices.country = [];
                const scopeValue = Array.isArray(urlQuery.dataScope) ? urlQuery.dataScope : [urlQuery.dataScope];
                facetsWithoutDataServices.country = [...new Set([...facetsWithoutDataServices.country, ...scopeValue])];
            }

            const facetObject = this.createFacetObject(facetsWithoutDataServices);
            const encodedFacets = encodeURIComponent(JSON.stringify(facetObject));
            const readableFacets = encodedFacets
                .replace(/%3A/g, ':')
                .replace(/%5B/g, '[')
                .replace(/%5D/g, ']')
                .replace(/%2C/g, ',');

            const params = dataServicesParam + countryDataParam + scoringParam + dateTypeParam + minDateParam + maxDateParam + fieldsParam;

            let url;
            if (urlQuery.query) {
                url = baseUrl + "search?q=" + urlQuery.query + filter + params +
                    (this.includes ? "&includes=" + this.includes : "") +
                    "&facets=" + readableFacets;
            } else {
                url = baseUrl + "search?" + filter.substring(1) + params +
                    (this.includes ? "&includes=" + this.includes : "") +
                    "&facets=" + readableFacets;
            }
            this.apiRequestUrl = url;
            return url;
        },
        initDatasets() {
            this.$nextTick(() => {
                this.$Progress.start();
                const loadParams = {
                    locale: this.$route.query.locale,
                    fields: this.$route.query.fields,
                };
                if (this.selectedOption === 'datasets' || this.selectedOption === 'all') {
                    loadParams.minDate = this.$route.query.minDate;
                    loadParams.maxDate = this.$route.query.maxDate;
                    loadParams.dateType = this.$route.query.dateType;
                }
                this.loadDatasets(loadParams)
                    .then(() => {
                        this.setPageCount(
                            Math.ceil((this.getDatasetsCount || 0) / (this.getLimit || 10)) || 1
                        );
                        this.$Progress.finish();
                        $('[data-toggle="tooltip"]').tooltip({
                            container: "body",
                        });
                    })
                    .catch(() => this.$Progress.fail())
                    .finally(() => this.$root.$emit('contentLoaded'));
            });
        },
        facets() {
            const facets = {};
            for (const field of this.facetFields) {
                let urlFacets = this.$route.query[field];
                if (!urlFacets) urlFacets = [];
                else if (!Array.isArray(urlFacets)) urlFacets = [urlFacets];
                if (field === 'country') {
                    urlFacets = urlFacets.filter(f => f !== 'countryData');
                }
                facets[field] = urlFacets;
            }
            return facets;
        },
        facetTitle(fieldId) {
            return fieldId === 'scoring' ?
                this.i18n.global.t('message.header.navigation.data.metadataquality')
                : this.i18n.global.t(`message.datasetFacets.facets.${fieldId.toLowerCase()}`);
        },
        filterSuggestions() {
            if (!this.titleQuery) {
                this.filteredSuggestions = [];
                return;
            }
            if (this.searchFields.includes('categories.*')) {
                this.filteredSuggestions = this.categorySuggestions.filter(suggestion =>
                    suggestion.toLowerCase().includes(this.titleQuery.toLowerCase())
                );
            }
        },
        selectSuggestion(suggestion) {
            this.titleQuery = suggestion;
            this.showSuggestions = false;
        },
        handleECCheckboxChange(value, state) {
            if (state) {
                if (!this.searchFields.includes(value)) {
                    this.searchFields.push(value);
                }
            } else {
                const index = this.searchFields.indexOf(value);
                if (index > -1) {
                    this.searchFields.splice(index, 1);
                }
            }
            this.updateSearchFieldsInUrl();
        },
        handleAllPropertiesChange(state) {
            if (state) {
                this.searchFields = [];
                if (this.titleQuery && !this.query) {
                    this.query = this.titleQuery;
                }
            } else {
                if (this.query && !this.titleQuery) {
                    this.titleQuery = this.query;
                }
            }
            this.updateSearchFieldsInUrl();
        },
        updateSearchFieldsInUrl() {
            const currentQuery = { ...this.$route.query };
            if (this.selectedOption !== 'editorial-content') {
                if (this.searchFields.length > 0) {
                    currentQuery.fields = this.searchFields.join(',');
                } else {
                    delete currentQuery.fields;
                }
            } else {
                delete currentQuery.fields;
            }
            const activeQuery = (this.selectedOption !== 'editorial-content' && this.searchFields.length > 0) ? this.titleQuery : this.query;
            if (activeQuery && activeQuery.trim()) {
                currentQuery.query = activeQuery;
            } else if (!activeQuery || !activeQuery.trim()) {
                if (!this.query && !this.titleQuery) {
                    delete currentQuery.query;
                }
            }
            this.$router.replace({ query: currentQuery }).then(() => {
                clearTimeout(this.countRequestTimer);
                this.countRequestTimer = setTimeout(() => {
                    this.countRequest();
                }, 300);
            }).catch(error => {
                console.error('Error updating route:', error);
                clearTimeout(this.countRequestTimer);
                this.countRequestTimer = setTimeout(() => {
                    this.countRequest();
                }, 300);
            });
        },
        sortedFacets() {
            const facets = [...this.getAllAvailableFacets];
            facets.sort((a, b) => {
                const indexA = this.defaultFacetOrder.indexOf(a.id);
                const indexB = this.defaultFacetOrder.indexOf(b.id);
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });
            return facets;
        },
        handleEnter() {
            this.applySearch();
        },
        handleInput() {
            if (this.searchFields.length > 0) {
                if (this.$refs.highlight) {
                    this.$refs.highlight.innerHTML = this.highlightText(this.titleQuery || '');
                }
                this.query = this.titleQuery;
            } else {
                if (this.$refs.highlight) {
                    this.$refs.highlight.innerHTML = this.highlightText(this.query || '');
                }
                this.titleQuery = this.query;
            }
        },
        handleBlur() {
            const currentQuery = { ...this.$route.query };
            const activeQuery = this.searchFields.length > 0 ? this.titleQuery : this.query;
            if (activeQuery && activeQuery.trim()) {
                currentQuery.query = activeQuery;
            } else {
                delete currentQuery.query;
            }
            this.$router.replace({ query: currentQuery })
                .then(() => {
                    clearTimeout(this.countRequestTimer);
                    this.countRequestTimer = setTimeout(() => {
                        this.countRequest();
                    }, 300);
                })
                .catch(error => {
                    console.error('Error updating route:', error);
                    clearTimeout(this.countRequestTimer);
                    this.countRequestTimer = setTimeout(() => {
                        this.countRequest();
                    }, 300);
                });
        },
        updateUrlWithDates() {
            const currentQuery = { ...this.$route.query };
            if (this.selectedOption === 'datasets' || this.selectedOption === 'all') {
                if (this.minDateUTC) {
                    currentQuery.minDate = this.minDateUTC;
                } else {
                    delete currentQuery.minDate;
                }

                if (this.maxDateUTC) {
                    currentQuery.maxDate = this.maxDateUTC;
                } else {
                    delete currentQuery.maxDate;
                }
                if (this.dateType && this.dateType !== 'modified') {
                    currentQuery.dateType = this.dateType;
                } else {
                    delete currentQuery.dateType;
                }

                currentQuery.dateType = this.dateType;
            } else {
                delete currentQuery.minDate;
                delete currentQuery.maxDate;
                delete currentQuery.dateType;
            }
            this.$router.replace({
                query: currentQuery
            }).catch(error => {
                console.error('Error updating route:', error);
            });
        },
        updateUrlWithDateType() {
            this.updateUrlWithDates();
        },
        updateMinDate(selectedDate) {
            if (selectedDate) {
                const date = new Date(selectedDate);
                const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1));
                this.minDateUTC = utcDate.toISOString();
            } else {
                this.minDateUTC = null;
            }
            this.updateUrlWithDates();
        },
        updateMaxDate(selectedDate) {
            if (selectedDate) {
                const date = new Date(selectedDate);
                const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
                const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), lastDay));
                this.maxDateUTC = utcDate.toISOString();
            } else {
                this.maxDateUTC = null;
            }
            this.updateUrlWithDates();
        },
        facetIsSelected(field, item) {
            let facets = this.$route.query[field] || [];
            if (!Array.isArray(facets)) facets = [facets];
            return facets.includes(item.id);
        },
        clear() {
            this.closeAllDropdowns()
        },
        has,
        truncate,
        getTranslationFor,
        getImg,
        initFacetOperator() {
            if (this.showCatalogDetails)
                this.setFacetOperator("AND");
            else {
                const op = this.$route.query.facetOperator;
                if (op === "AND" || op === "OR") this.setFacetOperator(op);
            }
        },
        initFacetGroupOperator() {
            if (this.showCatalogDetails)
                this.setFacetGroupOperator("AND");
            else {
                const op = this.$route.query.facetOperator;
                if (op === "AND" || op === "OR") this.setFacetGroupOperator(op);
            }
        },
        back() {
            this.$router.push({
                path: '/combined',
            });
        },
        setActive(field) {
            this.activeField = field;
        },
        clearInput() {
            event.preventDefault();
            this.query = '';
            this.titleQuery = '';
            this.descQuery = '';
            this.keywordsQuery = '';
            this.categoriesQuery = '';
            this.showSuggestions = false;
            this.activeField = null;

            if (this.$refs.highlight) {
                this.$refs.highlight.innerHTML = '';
            }
            const currentQuery = { ...this.$route.query };
            delete currentQuery.query;

            if (this.getDatasetsCount === 0) {
                this.clearAll();
            } else {
                this.$router.replace({ query: currentQuery }).catch(error => {
                    console.error('Error updating route:', error);
                });
            }
        },
        async clearAll() {
            window.scrollTo(0, 0);
            this.$router.replace({ path: this.$route.path, query: {} }).then(() => {
                window.location.reload();
            });
        },
        handleEmpty(field) {
            if (this[field] === '') {
                this.clearInput()
            }
        },
        applySearch() {
            const currentQuery = { ...this.$route.query };
            currentQuery.locale = this.locale || 'en';

            if (this.selectedOption === 'datasets' || this.selectedOption === 'all') {
                if (this.minDateUTC) currentQuery.minDate = this.minDateUTC;
                else delete currentQuery.minDate;

                if (this.maxDateUTC) currentQuery.maxDate = this.maxDateUTC;
                else delete currentQuery.maxDate;

                currentQuery.dateType = this.dateType;
 
            } else {
                delete currentQuery.minDate;
                delete currentQuery.maxDate;
                delete currentQuery.dateType;
            }

            if (this.selectedOption !== 'editorial-content' && this.searchFields.length) {
                const updatedFields = this.searchFields.map(field => {
                    if (this.selectedLanguage !== '*') {
                        const fieldName = field.replace('.*', '');
                       if (this.searchFields.includes('categories.*')) {
                                return `${fieldName}.label.${this.selectedLanguage}`;
                            }
                        if (this.searchFields.includes('keywords.*')) {
                                return `${fieldName}.*`;
                            }
                        return `${fieldName}.${this.selectedLanguage}`;
                    } 
                    return field;
                });

                currentQuery.fields = updatedFields.join(',');

                if (this.currentQueryValue && this.currentQueryValue.trim()) {
                    currentQuery.query = this.currentQueryValue;
                }
            } else if (this.selectedOption === 'editorial-content') {

                delete currentQuery.fields;
                if (this.query) {
                    currentQuery.query = this.query;
                }
            } else if (this.query) {
                currentQuery.query = this.query;
            }

            currentQuery.page = 1;

            if (this.selectedOption === 'all') {
                this.$router.push({
                    path: '/combined',
                    query: currentQuery
                });
            } else {
                this.$router.push({
                    path: '/' + this.selectedOption,
                    query: currentQuery
                });
            }
        },
        selectOption(value) {
            this.selectedOption = value;
            const currentQuery = { ...this.$route.query };
            currentQuery.selectedOption = value;

            if (value !== 'datasets' && value !== 'all') {
                delete currentQuery.minDate;
                delete currentQuery.maxDate;
                delete currentQuery.dateType;
            }

            if (value === 'editorial-content') {
                delete currentQuery.fields;
            }

            this.$router.replace({ query: currentQuery }).then(() => {
                this.countRequest();
            }).catch(error => {
                console.error('Error updating route:', error);
                this.countRequest();
            });
        },
        updateLanguageInUrl() {
            const currentQuery = { ...this.$route.query };
            currentQuery.selectedLanguage = this.selectedLanguage;

            this.$router.replace({ query: currentQuery }).then(() => {
                this.updateSearchFieldsInUrl();
            }).catch(error => {
                console.error('Error updating route:', error);
                this.updateSearchFieldsInUrl();
            });
        },
        getLocalizedTitle(title) {
            if (typeof title === 'object') {
                return title[this.locale] || title.en || 'N/A';
            }
            return title;
        },
        filteredItems(group) {
            const searchQuery = this.searchQueries[group.id]?.toLowerCase() || '';
            return group.items.filter(item => {
                const title = this.getLocalizedTitle(item.title).toLowerCase();
                return title.includes(searchQuery);
            });
        },
        toggleDropdown(groupId) {
            this.openDropdowns[groupId] = !this.openDropdowns[groupId];
        },
        closeAllDropdowns() {
            Object.keys(this.openDropdowns).forEach(key => {
                this.openDropdowns[key] = false;
            });
        },
        chunkArray(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        },
        getFacetTranslation,
        getTitle(item) {
            return this.fieldId === 'dataScope' && this.i18n.global.te(`message.datasetFacets.facets.datascopeField.${item.id}`) ?
                this.i18n.global.t(`message.datasetFacets.facets.datascopeField.${item.id}`)
                : this.getFacetTranslationWrapper(this.fieldId, item.id, this.$route.query.locale, item.title);
        },
        getFacetTranslationWrapper(fieldId, facetId, userLocale, fallback) {
            return fieldId === 'scoring'
                ? this.i18n.global.t(`message.datasetFacets.facets.scoring.${facetId}`)
                : this.getFacetTranslation(fieldId, facetId, userLocale, fallback);
        },
        generateApiUrl() {
            const currentQuery = { ...this.$route.query };
            let queryParams = new URLSearchParams();
            const baseUrl = this.baseUrl + "search?";

            if (this.query || currentQuery.query) {
                queryParams.append("q", this.query || currentQuery.query || '');
            }

            queryParams.append("filter", this.selectedOption || 'dataset');
            queryParams.append("includes", this.includes);

            if (this.dateType) {
                queryParams.append("dateType", this.dateType);
            }

            if (this.getFacets && Object.keys(this.getFacets).length > 0) {
                const encodedFacets = encodeURIComponent(JSON.stringify(this.getFacets));
                const readableFacets = encodedFacets
                    .replace(/%3A/g, ':')
                    .replace(/%5B/g, '[')
                    .replace(/%5D/g, ']')
                    .replace(/%2C/g, ',');
                queryParams.append("facets", readableFacets);
            }

            if (this.selectedOption !== 'editorial-content' && this.searchFields && this.searchFields.length > 0) {
                queryParams.append("fields", this.searchFields.join(','));
            }
            if (this.minDateUTC) {
                queryParams.append("minDate", this.minDateUTC);
            }
            if (this.maxDateUTC) {
                queryParams.append("maxDate", this.maxDateUTC);
            }

            this.apiRequestUrl = baseUrl + queryParams.toString();
            return this.apiRequestUrl;
        },
        copyApiUrl() {
            this.generateApiRequestUrl();
            navigator.clipboard.writeText(this.apiRequestUrl).then(() => {
                this.showCopiedModal = true;
                setTimeout(() => {
                    this.showCopiedModal = false;
                }, 5000);
            }).catch(err => {
                console.error('Fehler beim Kopieren in die Zwischenablage: ', err);
            });
        },
        openApiRequest() {
            this.generateApiRequestUrl();
            window.open(this.apiRequestUrl, "_blank");
        },
        createFacetObject(facets) {
            const fullFacetObject = {
                "country": [],
                "catalog": [],
                "format": [],
                "formatTypes": [],
                "scoring": [],
                "license": [],
                "categories": [],
                "publisher": [],
                "subject": [],
                "keywords": [],
                "is_hvd": [],
                "hvdCategory": [],
                "superCatalog": []
            };
            Object.keys(facets).forEach(key => {
                if (Object.prototype.hasOwnProperty.call(fullFacetObject, key)) {
                    fullFacetObject[key] = facets[key];
                }
            });

            return fullFacetObject;
        },
        selectMobileOption(value) {
            this.selectedOption = value;
            this.mobileDropdownOpen = false;

            const currentQuery = { ...this.$route.query };
            currentQuery.selectedOption = value;

            if (value !== 'datasets' && value !== 'all') {
                delete currentQuery.minDate;
                delete currentQuery.maxDate;
                delete currentQuery.dateType;
            }

            if (value === 'editorial-content') {
                delete currentQuery.fields;
            }

            this.$router.replace({ query: currentQuery }).then(() => {
                this.countRequest();
            }).catch(error => {
                console.error('Error updating route:', error);
                this.countRequest();
            });
        },
        handleClickOutside(e) {
            if (this.mobileDropdownOpen && this.$refs.mobileDropdown && !this.$refs.mobileDropdown.contains(e.target)) {
                this.mobileDropdownOpen = false;
            }
        },
        formatCountWithSpaces(count) {
            if (count === null || count === undefined) return '';

            const countStr = count.toString();
            const reversed = countStr.split('').reverse();
            const chunks = [];

            for (let i = 0; i < reversed.length; i += 3) {
                chunks.push(reversed.slice(i, i + 3).join(''));
            }

            return chunks.join(' ').split('').reverse().join('');
        },
        formatCount(value) {
            if (this.isLoading) return '...';
            return this.formatCountWithSpaces(value || 0);
        },
    },
    mounted() {
        this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip({
                container: "body",
                html: true,
                trigger: 'hover',
                delay: { show: 100, hide: 1200 },
            });

            // Event-Listener für Tooltip-Links
            $(document).on('click', '.tooltip a', function (e) {
                const url = $(this).attr('href');
                window.open(url, '_blank');
                $('.tooltip').tooltip('hide');
            });
        });

        if (navigator.userAgent.includes('Firefox')) {
            const preventFocusScroll = (e) => {
                if (e.target.matches('input[type="radio"], input[type="checkbox"]')) {
                    const scrollY = window.pageYOffset;
                    const scrollX = window.pageXOffset;
                    requestAnimationFrame(() => {
                        window.scrollTo(scrollX, scrollY);
                    });
                }
            };

            document.addEventListener('click', this.handleClickOutside);
            document.addEventListener('focusin', preventFocusScroll, { passive: false });
            document.addEventListener('focus', preventFocusScroll, { passive: false, capture: true });
            this.$el.addEventListener('click', (e) => {
                if (e.target.matches('input[type="radio"], input[type="checkbox"]')) {
                    const scrollY = window.pageYOffset;
                    const scrollX = window.pageXOffset;

                    setTimeout(() => {
                        window.scrollTo(scrollX, scrollY);
                    }, 0);
                }
            });
        }
        if (this.$refs.highlight) {
            this.$refs.highlight.innerHTML = this.highlightText(this.query);
        }
        // this.countRequest();
    },
    created() {
        this.initFacets();
        this.setFacets(this.facets());
        this.initDatasets();
        if (this.$route.query.minDate) {
            const date = new Date(this.$route.query.minDate);
            this.minDate = date;
        }

        if (this.$route.query.maxDate) {
            const date = new Date(this.$route.query.maxDate);
            this.maxDate = date;
        }
        window.addEventListener('click', (e) => {
            const dropdowns = document.querySelectorAll('.multiselect-container');
            let clickedOutside = true;

            dropdowns.forEach(dropdown => {
                if (dropdown.contains(e.target)) {
                    clickedOutside = false;
                }
            });

            if (clickedOutside) {
                this.closeAllDropdowns();
            }
        });

        let lastScrollY = window.scrollY;
        this.$router.beforeEach((to, from, next) => {
            lastScrollY = window.scrollY;
            next();
        });
        this.$router.afterEach((to, from) => {
            if (to.path !== from.path) {
                window.scrollTo(0, lastScrollY);
            }
        });
        this.$nextTick(() => {
            this.generateApiUrl();
        });
    },
    beforeDestroy() {
        if (this.countRequestTimer) {
            clearTimeout(this.countRequestTimer);
        }
        document.removeEventListener('click', this.handleClickOutside);
    },
    updateQueryParam(key, value) {
        const currentQuery = { ...this.$route.query };
        if (value) {
            currentQuery[key] = value;
        } else {
            delete currentQuery[key];
        }
        this.$router.replace({ query: currentQuery }).catch(error => {
            console.error('Error updating route:', error);
        });
    },

};
</script>

<style lang="scss" scoped>

    .page-btn {
  height: 48px;
  border-radius: 4px;
  padding: 16px;
  width: 220px;
  display: flex;
  align-items: center;
  text-decoration: none;
  border: 2px solid #0E47CB;
  justify-content: center;
  background-color: #0E47CB;
  color: #fff;

  &:hover {
    background-color: #3E6CD5;
    color: #fff;
    border: 2px solid #3E6CD5;
  }

}
.language-search {
    display: flex;
    flex-direction: column;
    gap: 15px;
    background-color: #F4F4F4;
    border-radius: 5px;
    padding: 20px;
}

.checkbox-row {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
}

.language-selection {
    margin-top: 10px;
}

.all-props {
    padding: 20px 20px 20px 0px;
}

.count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 20px;
    line-height: 18px;
}

.loading-dots {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    min-width: 20px;
    justify-content: center;
    min-height: 20px;
}

.loading-dots .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #0e47cb;
    animation: loading-bounce 1.4s infinite ease-in-out both;
}

.loading-dots .dot:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dots .dot:nth-child(2) {
    animation-delay: -0.16s;
}

.loading-dots .dot:nth-child(3) {
    animation-delay: 0s;
}

@keyframes loading-bounce {

    0%,
    80%,
    100% {
        transform: scale(0.8);
        opacity: 0.5;
    }

    40% {
        transform: scale(1);
        opacity: 1;
    }
}

.copied-modal {
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #28a745;
    color: white;
    padding: 12px 20px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    font-size: 14px;
    animation: fadeInOut 5s ease-in-out;

    svg {
        flex-shrink: 0;
    }
}

@keyframes fadeInOut {
    0% {
        opacity: 0;
        transform: translateX(-50%) translateY(20px);
    }

    10%,
    90% {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
    }
}

.custom-search {
    margin-top: 94px;
    max-height: 50px;
}

.api-request-box {
    margin-top: 30px;
    margin-bottom: 40px;
    background-color: #f8f9fa;
}

.api-request-content {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
}

.api-url-container {
    position: relative;
    flex-grow: 1;
}

.api-url-field {
    width: 100%;
    padding: 12px 40px 12px 15px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-family: monospace;
    font-size: 14px;
    color: #555;
    background-color: #fff;
    overflow-x: auto;
    white-space: nowrap;
}

.copy-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #0e47cb;
    padding: 5px;
    border-radius: 3px;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e9ecef;
    }

    svg {
        vertical-align: middle;
    }
}

.api-request-btn {
    padding: 10px 15px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    height: 48px;

    svg {
        margin-right: 5px;
    }

    &:hover {
        background-color: #0b3aa8;
    }
}

.date-type-radio-group {
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
    margin-bottom: 15px;

    .radio-option {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-weight: 400;
        margin-bottom: 0;

        input[type="radio"] {
            margin-right: 8px;
            margin-bottom: 0;
            cursor: pointer;
            width: 18px;
            height: 18px;
            accent-color: #0e47cb; // Moderne Browser

            // Fallback für ältere Browser
            &:checked {
                background-color: #0e47cb;
                border-color: #0e47cb;
            }

            appearance: none;
            -webkit-appearance: none;
            border: 2px solid #d1d5db;
            border-radius: 50%;
            background-color: white;
            position: relative;
            transition: all 0.2s ease;

            &:checked {
                border-color: #0e47cb;
                background-color: #0e47cb;

                &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background-color: white;
                }
            }

            &:hover {
                border-color: #0e47cb;
            }

            &:focus {
                outline: none;
                box-shadow: 0 0 0 3px rgba(14, 71, 203, 0.1);
            }
        }

        .radio-label {
            cursor: pointer;
            user-select: none;
            transition: color 0.2s ease;
        }

        &:hover .radio-label {
            color: #0e47cb;
        }

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;

            input[type="radio"] {
                cursor: not-allowed;

                &:hover {
                    border-color: #d1d5db;
                }
            }

            .radio-label {
                cursor: not-allowed;
                color: #9ca3af;
            }

            &:hover .radio-label {
                color: #9ca3af;
            }
        }
    }
}

.radio {
    background-color: #fff;
    border: solid 1px #707070;
    min-height: 48px;
    padding: 8px;
    border-radius: 4px;
    width: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.radio-options label {
    margin-bottom: 0px;
    margin-right: 20px;
}

@media (max-width: 768px) {
    .api-request-content {
        flex-direction: column;
        align-items: stretch;
    }

    .api-url-field {
        font-size: 12px;
    }

    .api-request-btn {
        margin-top: 10px;
    }
}

.container {
    padding: 30px 20px 20px 15px !important;
}

textarea::placeholder {
    white-space: pre-line;
    /* Allows \n to act as line breaks */
}

.clear {
    position: absolute;
    margin-top: -107px !important;
    margin-left: 500px;
}

.btn-group .btn {
    font-weight: 300;
    border: 1px solid;
}

.btn-primary {
    background: #0e47cb !important;
    border: #0e47cb !important;
}

.back-btn {
    // font-weight: 500;
    // padding: 13px;
    padding: 10px;
    border: 1px solid;
    font-weight: 400;
}

.btn-more {
    font-weight: 500;

    a:hover {
        text-decoration: none;
        color: #fff;
    }
}

.btn-more:hover {
    a {
        text-decoration: none;
        color: #fff;
    }
}

.back-btn svg {
    margin-bottom: 2px;
    margin-right: 5px;
}

.btn svg {
    vertical-align: top
}

h2 {
    font-size: 20px;
    font-weight: 700;
}

h2 svg {
    margin-right: 5px;
    vertical-align: baseline;
}

h3 {
    font-weight: 600;
    font-size: 16px;
}

.info-box {
    background-color: #F4F4F4;
    padding: 15px;
    border-radius: 4px;
    height: auto;
    color: #363636;
    max-height: 265px;
    margin-top: 30px;
}

.details {
    list-style-type: none;
    margin-left: 5px;
    line-height: 30px;
}

.tooltip-icon {
    font-size: 15px;
    cursor: default;
    vertical-align: text-top;
}

.ad-tab {
    padding: 10px;
}

.box {
    background-color: #FBFBFB;
    padding: 25px;
    border-radius: 4px;
}

.label {
    font-weight: 700;
}

.text {
    padding: 10px;
    min-width: 610px;
    min-height: 100px;
    border: 0.4px solid #CDCDCD;
    border-radius: 4px;
}

.wrapper {
    position: relative;
    width: 100%;

    .clear-btn {
        position: absolute;
        top: 35px;
        left: 636px;
        z-index: 2;
        background: transparent;
        border: none;
        padding: 0;
        cursor: pointer;

        svg {
            width: 25px;
            height: 25px;
            color: #3f3f3f;
        }
    }

    .highlighted-content {
        white-space: pre-wrap;
        color: transparent;
        background: none;
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 10px;
        font-family: inherit;
        font-size: inherit;
        z-index: 1;
    }
}


.text-specific {
    padding: 10px;
    min-width: 500px;
    border: 0.4px solid #CDCDCD;
    border-radius: 4px;

}

.filled-input {
    border: 2px solid #0e47cb;
}

.month-year-picker {
    display: inline-flex;
}


.dash {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 5px;
}

.date-input {
    width: 200px;
    height: 40px;
    padding: 8px;
    border: 1px solid #CDCDCD;
    border-radius: 4px;

    &:focus {
        border-color: #0e47cb;
        outline: none;
    }
}

.date-input-wrapper {
    position: relative;
    display: inline-block;

    .calendar-icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        color: #707070;
        pointer-events: none;
        transition: color 0.2s ease;
    }

    .clear-date-btn {
        position: absolute;
        right: 35px;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        color: #3f3f3f;
        padding: 2px;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:hover {
            background-color: #e9ecef;
            color: #0e47cb;
        }

        svg {
            width: 18px;
            height: 18px;
            vertical-align: middle;
        }
    }

    &:hover {
        .calendar-icon {
            color: #0e47cb;
        }

        .date-input {
            border-color: #0e47cb;
        }
    }

    .date-input {
        width: 155px;
        height: 40px;
        padding: 8px 60px 8px 8px;
        border: 1px solid #CDCDCD;
        border-radius: 4px;
        transition: border-color 0.2s ease;

        &:focus {
            outline: none;

            &+.calendar-icon {
                color: #0e47cb;
            }
        }
    }
}

.month-year-picker {
    display: inline-flex;
    align-items: center;
    // gap: 10px;
}


.flatpickr-monthSelect-month {
    &.selected {
        background: #0e47cb !important;
    }
}

.flatpickr-current-month {
    display: flex;
    justify-content: center;
}

::placeholder {
    color: #acacac;
}

/* Mobile Dropdown */
.mobile-dropdown {
    position: relative;
    width: 100%;
}

.mobile-trigger {
    width: 100%;
    display: flex;
    align-items: center;
    gap: .75rem;
    background: #1546cf;
    color: #fff;
    border: 0;
    border-radius: 8px;
    padding: 10px 3rem 10px 1.25rem;
    font-weight: 600;
    cursor: pointer;
    position: relative;
    text-align: left;
}

.mobile-trigger .count-badge {
    background: #fff;
    color: #1546cf;
    font-weight: 600;
    border-radius: 999px;
    padding: .25rem .75rem;
    font-size: .85rem;
    line-height: 1;
    display: inline-block;
}

.mobile-trigger .divider {
    position: absolute;
    top: 8px;
    bottom: 8px;
    right: 48px;
    width: 1px;
    background: rgba(255, 255, 255, .65);
}

.mobile-trigger .arrow {
    position: absolute;
    right: 16px;
    width: 14px;
    height: 14px;
    transition: transform .2s;
}

.mobile-trigger .arrow::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' fill='none'%3E%3Cpolyline points='3 5 7 9 11 5'/%3E%3C/svg%3E") center/contain no-repeat;
    background: #fff;
}

.mobile-trigger .arrow.open {
    transform: rotate(180deg);
}

.mobile-trigger:focus {
    outline: 2px solid #0e47cb;
    outline-offset: 2px;
}

.mobile-menu {
    list-style: none;
    margin: .5rem 0 0;
    padding: .25rem;
    background: #fff;
    border: 1px solid #d6dff5;
    border-radius: 8px;
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 20;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .12);
}

.mobile-menu li button {
    width: 100%;
    background: transparent;
    border: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .6rem .75rem;
    font-weight: 500;
    cursor: pointer;
    border-radius: 6px;
    color: #183366;
}

.mobile-menu li button:hover,
.mobile-menu li button:focus {
    background: #f0f5ff;
    outline: none;
}

.badge-inline {
    background: #1546cf;
    color: #fff;
    border-radius: 999px;
    padding: .2rem .55rem;
    font-size: .75rem;
    font-weight: 600;
    line-height: 1;
}


/* Multi Select */
.facets-row-advanced {
    margin-left: -20px;
    display: grid;
    // grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 20px;
}

@media (max-width: 900px) {
    .facets-row-advanced {
        // grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .wrapper {
        .clear-btn {
            left: calc(100% - 65px);
            top: 35px;
        }
    }

    .facets-row-advanced {
        // grid-template-columns: 1fr;
    }
}

.facets-row-advanced>div {
    min-width: 0;
    width: 100%;
}

.facet-group,
.select-facet,
.multiselect-container {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
}


.facet-label {
    font-weight: 700;
    margin-top: 25px;
    max-width: 300px;
}

.multiselect-container {
    position: relative;
    width: 100%;
    max-width: 300px;
}

.multiselect-trigger {
    padding: 0px 0px 0px 10px;
    border: 1px solid #CDCDCD;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    // width: 300px;
    min-height: 48px;
    border-color: #707070;

    &:hover {
        border-color: #0e47cb;
    }
}

.multiselect-wrapper {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border-top: none;
    border: 1px solid #CDCDCD;
    border-radius: 0px 0px 4px 4px;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    width: 300px;
}

.ecl-select__icon {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #0e47cb !important;
}

.ecl-select__icon-shape {
    fill: #fff !important;
}

.trigger-content {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: nowrap;
}

.filter-badge {
    align-items: center;
    background-color: #0e47cb;
    border-radius: .75rem;
    color: #fff;
    display: inline-flex;
    height: auto;
    justify-content: center;
    min-width: 35px;
    padding: .25rem;
    position: relative;
    text-align: center;
    margin-right: 5px;
}

.position-relative {
    position: relative;
}

.suggestions-container {
    position: absolute;
    top: 60%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #CDCDCD;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 500px;
}

.suggestion-item {
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: #f5f5f5;
    }

    .category-label {
        font-size: 12px;
        padding: 1px 10px 1px 10px;
        background-color: #f0f0f0;
        border-radius: 4px;
        color: #666;
        margin-left: 8px;
    }
}

.facets-row-advanced {
    display: grid;
    // grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 20px;
}

.multiselect-search {
    padding: 8px;
    border: none;
    width: -webkit-fill-available;
    margin: 10px;
    border-radius: 5px;
    border: 1px solid #707070;
    box-shadow: 0 2px 4px #09318e14 inset, 0 0 10px #09318e0a inset, 0 4px 5px #09318e0a inset, 0 -4px 4px #09318e0a inset;
    border-radius: 4px 4px 4px 4px;
    width: 280px;
    margin: 10px;
}

.multiselect-dropdown {
    color: #3f3f3f;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border-radius: 0 0 4px 4px;
    border-top: solid 1px #dadada;
}

.multiselect-item {
    padding: 8px;
    cursor: pointer;

    &:hover {
        background-color: #f5f5f5;
    }
}

.checkbox-container {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.checkbox-container input {
    min-width: auto;
    margin-left: 10px;
}

.checkbox-label {
    flex: 1;
}

.btn-container {
    border-top: 1px solid #dadada;
    padding: 10px;
}

.select-custom {
    margin-top: 10px;
    width: 100%;

}

// Radio design

.radio {
    background-color: #fff;
    border: solid 1px #707070;
    min-height: 48px;
    padding: 8px;
    border-radius: 4px;
    width: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.radio-options label {
    margin-bottom: 0px;
    margin-right: 20px;
}

.checkbox-group {
    font-weight: 400;
    display: inline-flex;
    gap: 15px;
}

.debug {
    position: fixed;
    right: 20px;
    top: 20px;
    border-radius: 20px;
    width: 400px;
    z-index: 999999;
    padding: 20px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    display: none;
}

@media (max-width: 900px) {
    .facets-row-advanced {
        // grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {

    .info-box {
        margin-top: 10px;
    }

    .text {
        font-size: 14px;
        min-width: 250px;
    }

    .dp__input {
        font-size: 10px !important;
    }

    .facets-row-advanced {
        // grid-template-columns: 1fr;
    }

}

// Scope Select Bar Styles
#scope-select-advanced {
    margin-bottom: 2rem;
    width: fit-content;

    >div {
        display: flex;
        flex-direction: row;
        list-style-type: none;
        border-radius: 4px;
    }
}

.scope-select-block {
    display: flex;
    flex-direction: row;

   .nav-item {
  border: 1px solid #c0c0c0;
  border-radius: 0;
  box-sizing: border-box;
  margin-right: -1px;
  position: relative; /* Verhindert Verschiebung */
  z-index: 1;

  &:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  &:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem ;
    margin-right: 0;
  }

  &.router-link-active {
    border-color: #0e47cb;
    z-index: 2; /* Aktives Element über anderen */
  }

  .router-link-active {
    background-color: #0e47cb;
  }

  .nav-link {
    cursor: pointer;
    outline: none !important;
    box-shadow: none !important; /* Entfernt Bootstrap focus shadow */
    
    &:focus,
    &:active,
    &:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
  }
}
}

.scope-tab-content {
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;


    .label {
        margin-right: 0.5rem;
        font-weight: 500;
    }

    .count {
        border: 1px solid #0e47cb;
        padding: 0px 10px 0px 10px;
        font-size: 16px;
        border-radius: 15px;
    }

    span {
        white-space: nowrap;
    }
}

.nav-link {
  outline: none !important;
  box-shadow: none !important;
  border: none !important; /* Falls Bootstrap einen Border hinzufügt */
  
  &:focus,
  &:active,
  &:focus-visible {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }
}

.label {
  margin-right: 0.5rem;
}

a.router-link-inactive {
  color: #0e47cb !important;
}
a.router-link-active {
  color: white !important;
}
a.router-link-active .count {
  background-color: white;
  border-color: white;
  color: #0e47cb;
}

.nav-item {
  width: 100%
}

.scope-tab-content {
  white-space: nowrap;
  span {
    white-space: nowrap;
  }
}


@media screen and (max-width: 992px) {
    .scope-select-block {
        flex: 1;
        flex-direction: column;


        .scope-tab-content {
            width: 100%;
        }
    }
}

@media screen and (max-width: 767.5px) {
    #scope-select-advanced>div {
        border-color: #0e47cb;
        margin-left: 0;
    }

    .scope-select-block .nav-item {
        border-color: #0e47cb;
    }
}

@media screen and (max-width: 575.5px) {
    #scope-select-advanced>div {
        flex-direction: column;
    }
}
</style>